import './MunMaual_main.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import HongButton from '../comm/HongButton';
import HongButtonNew from '../comm/HongButtonNew';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MunViewer from './MunViewer'; 
import MunCart from './MunCart';
import MunMenu from './MunMenu';
import Img2pdf from '../img2pdf/Img2pdf';
import { setIsModalSaveTest, setListCart, setIsFastSearch_saveTest } from '../reduxToolkit/redux';

const MunMaual_main = ({ selectedUnitItem, setIsFastSearch }) => {
  const listCart = useSelector((state) => state.reduxStore.listCart);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]); // 배열로 변경
  // const [listCart, setListCart] = useState([]); // 장바구니 리스트
  const [isSelected, setIsSelected] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [munSolDap, setMunSolDap] = useState('mun');

  const urlParams = new URLSearchParams(window.location.search);
  const isModalSaveTestNewValue = urlParams.get('isModalSaveTestNew');
 
  const location = useLocation();


  useEffect(() => {
    fncSelect_list();
    // dispatch(setIsModalSaveTest(false));
  }, [selectedUnitItem]);



function fncSelect_list() {
  const nodekey = selectedUnitItem.value; // 선택된 항목에서 nodekey 가져오기

  if (!nodekey) return; // nodekey가 없으면 함수 종료
  fnc.sendAxios('/kuesbMunMaualRoutes/select/munList', { nodekey }, (res) => {

    if (res && Array.isArray(res)) {
      const newList = getRecords(res);
      setList(newList);
    } else {
      alert('검색에 실패했습니다.');
    }
  });

  function getRecords(res) {
    return res.map(item => ({
        시험지명: item["시험지명"],
        문항번호: item["문항번호"],
        연번: item["연번"],
        no: item["no"],
        정답: item["정답"],
        Img단: item["Img단"],
        imgSize: item["imgSize"],
        imgSizeSol: item["imgSizeSol"],
        이미지코드: item["이미지코드"],
        대단원: item["대단원"],
        중단원: item["중단원"],
        소단원: item["소단원"],
        유형: item["유형"],
        폴더: item["폴더"],
        난이도: item["난이도"],
        난이도Idx: item["난이도Idx"],
        공통지문: item["공통지문"],
        문풀답: item["문풀답"],
        isSelected: false 
    }));
  }
}

function onSelect(item, index) {
  // 이미 장바구니에 있는지 확인
  const isInCart = listCart.some(cartItem => cartItem.문항번호 === item.문항번호);
  
  if (isInCart) {
    // 장바구니에서 제거
    const updatedCart = listCart.filter(cartItem => cartItem.문항번호 !== item.문항번호);
    dispatch(setListCart(updatedCart));
    
    // list에서 해당 항목의 isSelected를 false로 설정
    const updatedList = list.map((el) => {
      if (el.문항번호 === item.문항번호) {
        return { ...el, isSelected: false };
      }
      return el;
    });
    setList(updatedList);
  } else {
    // 장바구니에 추가
    const newItem = { ...item, isSelected: true };
    dispatch(setListCart([...listCart, newItem]));
    
    // list에서 해당 항목의 isSelected를 true로 설정
    const updatedList = list.map((el) => {
      if (el.문항번호 === item.문항번호) {
        return { ...el, isSelected: true };
      }
      return el;
    });
    setList(updatedList);
  }
  
  // 선택 후 자동으로 다음 문제 보여주기
  const nextIndex = index + 1;
  if (nextIndex < list.length) {
    const nextItem = list[nextIndex];
    setSelectedItem(nextItem);
  } else {
    console.log('마지막 문제입니다.');
  }
}

// 장바구니에서 아이템 제거 함수
function handleRemoveFromCart(itemToRemove, cartIndex) {
  // 원본 리스트에서 해당 아이템의 isSelected를 false로 변경
  const updatedList = list.map(el => {
    if (el.문항번호 === itemToRemove.문항번호) {
      return {
        ...el,
        isSelected: false
      };
    }
    return el;
  });
  
  setList(updatedList);
  // 장바구니 업데이트
  const updatedCart = listCart.filter((_, index) => index !== cartIndex);
  // setListCart(updatedCart);
  dispatch(setListCart(updatedCart));
  
}

function onRowClick(item) {
  setMunSolDap('mun'); // 문제로 설정
  setSelectedItem(item);
} 

function onClearFromMenu() {//장바구니를 비웁니다
  // setListCart([]);
  dispatch(setListCart([]));
  const updateList = list.map(item => ({ ...item, isSelected: false })); // 선택된 문항 초기화
  setList(updateList);
}

//=========================================
  return (
    <>
    <S.Section>
      <div className='MunMaual_main'>
        <section className='sec-main3'>
          <div className='box-main'>
            <div className='table-wrapper'>
              <div className='table-header'>
                <table>
                  <thead>
                    <tr>
                      <th>번호</th>
                      <th>대단원</th>
                      <th>중단원</th>
                      <th>소단원</th>
                      <th>유형</th>
                      <th>난이도</th>
                      <th>문제</th>
                      <th>공통지문</th>
                      <th>선택</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className='table-body-container'>
                <table>
                  <tbody>
                    {list && list.map((item, index) => (
                      <tr
                        key={index}
                        className={`${item.isSelected ? 'selected' : ''}${selectedItem && selectedItem.문항번호 === item.문항번호 ? ' selectedRow' : ''}`}
                        onClick={() => onRowClick(item)}
                        onDoubleClick={() => onSelect(item, index)}
                      >
                        <td>{index + 1}</td>
                        <td>{item.대단원}</td>
                        <td>{item.중단원}</td>
                        <td>{item.소단원}</td>
                        <td>{item.유형}</td>
                        <td>{item.난이도}</td>
                        <td>{item.문항번호}</td>
                        <td>{item.공통지문}</td>
                        <td>
                          <HongButtonNew
                            className={`btnReport ${item.isSelected ? 'h-btn-red' : 'h-btn-green'}`}
                            onClick={(e) => {
                              e.stopPropagation();      // ⭐ 부모(tr)의 클릭 이벤트 전파 중단(onClick로 해야함)
                              onSelect(item, index);    // 버튼 전용 이벤트만 실행
                            }}
                          >
                            {item.isSelected ? '해제' : '선택'}
                          </HongButtonNew>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <section className='sec-menu'>
          <div className='box-component1'>
              <MunViewer 
                selectedItem={selectedItem} 
                munSolDap={munSolDap} />
          </div>

          <div className='box-component2'>
                <MunMenu 
                  onClearFromMenu={onClearFromMenu}
                  setListCart={setListCart} 
                  // listCart={listCart} 
                  setMunSolDap={setMunSolDap}
                  setIsFastSearch={setIsFastSearch} />
          </div>

          <div className='box-component3'>
              <MunCart
                // listCart={listCart}
                onRemoveFromCart={handleRemoveFromCart}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                setMunSolDap={setMunSolDap}
              />
        </div> 
        </section>
      </div>
    </S.Section>

 
    </>
  );
};

export default MunMaual_main;